import { Asset } from '../../asset/asset.dto';
import { ASSETS_STORE, IndexedService } from '@damofire/data-commons';
import { Injectable } from '@angular/core';
import { NetworkService } from '@damofire/data-angular-commons';
import { RemoteService } from './remote.service';
import { FirebaseAssetService } from '../../asset/firebase-asset.service';

@Injectable()
export class AssetRemoteService extends RemoteService<Asset> {
  constructor(
    protected readonly idbService: IndexedService,
    protected readonly networkService: NetworkService,
    private readonly firebaseAssetService: FirebaseAssetService,
  ) {
    super(ASSETS_STORE, idbService, networkService);
  }

  async add(division: string, data: Asset[]): Promise<void> {
    data = data.map((asset) => {
      const { statistics, riskLevel, ...assetNoStats } = asset;
      return assetNoStats;
    });
    await this.firebaseAssetService.create(division, data);
  }

  async delete(division: string, data: Asset[]): Promise<void> {
    await this.firebaseAssetService.delete(division, data);
  }

  async update(division: string, data: Asset[]): Promise<void> {
    data = data.map((asset) => {
      const { statistics, riskLevel, ...assetNoStats } = asset;
      return assetNoStats;
    });
    await this.firebaseAssetService.updateBatch(data);
  }
}
